import { render, staticRenderFns } from "./SalePriceInfo.vue?vue&type=template&id=49b13e01&"
import script from "./SalePriceInfo.vue?vue&type=script&lang=ts&"
export * from "./SalePriceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports